import React from "react";
import {TableDateSearchProvider} from "../Context/TableDateSearchContext.jsx";
import {ResponsiveView} from "../../components/ResponsiveView/ResponsiveView.jsx";
import {Devices} from "../../components/ResponsiveView/consts.js";
import AdminDeliveryProviderInvoices from "./AdminDeliveryProviderInvoices.jsx";

export const AdminDeliveryProviderInvoicesWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="adminDeliveryProviderInvoicesSearchDate">
            <ResponsiveView devices={[Devices.desktop]}>
                <AdminDeliveryProviderInvoices />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
